import React, { useRef } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import ArrowNext from '../../../assets/images/front/svg/arrow-next.svg'
import ArrowBg from '../../../assets/images/front/svg/arrow-bg.svg'
import Review from '../Review/Review'

const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
}

const Reviews: React.FC = () => {
  const sliderRef = useRef<Slider | null>(null)
  const handleNext = () => {
    sliderRef.current?.slickNext()
  }
  return (
    <>
      <div className="bg-[#00A0E3] w-full py-8 lg:px-0 reviews">
        <h2 className="text-wrapper-16">Přesvědčte se sami</h2>
        <div className="px-4 overflow-hidden">
          <div className="container mx-auto pt-12 overflow-hidden relative">
            <Slider ref={sliderRef} {...settings}>
              <Review
                name="Adéla Janošková"
                stars={5}
                text="Dohlavy_online, to je to místo, které mě provedlo a připravilo na přijímací zkoušky z matematiky. Už od první třídy jsem na tom v matematice byla jinak, než se očekávalo. Zkrátka mi nešla (časté chyby z nepozornosti). Čím více se začal přibližovat můj přijímačkový rok, kdy bude řada na mě, tím víc jsem potřebovala a hledala pomoc. Našla jsem ji!
Popravdě… tento účet byl pro mě jediným „průvodcem“ přípravou na přijímačky. Neměla jsem potřebu absolutně žádnou potřebu… hledat někoho jiného. Vše, co jsem potřebovala se doučit a nacpat do hlavy… v tom mi Dohlavy_online značně pomohlo. 😄
Vše bylo vysvětleno moc hezky, chápala jsem, vyhovovalo mi to, některé věci byly i podány zábavnou formou, což si myslím, že je naprosto super! Třeba i některé lidé, kteří se neradi učí… troufnula bych si říct, že tohle by jim určitě pomohlo a bavilo je to! Opravdu to není žádná nuda! Vždycky jsem se těšila!
Mohu jen doporučit! 💯 "
              />
              <Review
                name="Claudie Kučerová"
                stars={5}
                text="Moc děkuji za doučování od Dohlavy, můžu vám ho doporučit, protože nikdo mě nenaučil na přijímačky lépe než oni, nevím co bych bez nich dělala a určitě se k nim připojte, ps: dostanou vás na vaši vysněnou školu 🥰"
              />
              <Review
                name="Nickdo"
                stars={5}
                text="Videa mě moc pomohli s učením na přijímací zkoušky. Vše je vysvětleno pochopitelně a i zábavnou formou. To je poprvé, kdy mě to učení opravdu bavilo. Mockrát Vám děkuji za vaši snahu, kdyby ne vy, tak bych měla o hodně bodů méně."
              />
              <Review
                name="Evelina Lavičková"
                stars={5}
                text="Díky přípravným kurzům v Modřanech se syn s přehledem dostal na vybranou školu. Předchozí roky na školu dost kašlal a na vysvědčeních se objevovaly trojky i čtyřky, pravidelné víkendové kurzy ho celkově nastartovaly k soustavné přípravě. Nejlépe investované peníze!"
              />
              <Review
                name="Adriana Kuželová"
                stars={5}
                text="Dohlavy všem na 100 % doporučuji, díky nim jsem se dostala na střední školu, kterou jsem chtěla ze všeho nejvíc. Bez nich bych byla jinak úplně ztracená!!"
              />
              <Review
                name="Jana Bernaskova"
                stars={5}
                text="Naprosto a zcela doporučuji !!! Vynikající výsledky, díky výuce pod taktovkou mladých lektorů moje dítě pochopilo i zdánlivě beznadějné příklady i souvislosti jak v matematice, tak i v češtině. Současně postupně získalo sebedůvěru a dosáhlo i úspěchů ve škole. S pomocí lektorů Dohlavy jsme dokázali, co se nám zdálo zkraje nemožné, dítě je nyní přijato na vysněnou střední školu. Děkujeme :o)"
              />
              <Review
                name="Radka Broumova"
                stars={5}
                text="S agenturou jsem byla spokojena už od roku 2017, kdy jsme od nich měli slečnu na angličtinu. Skvěle kluky připravila nad rámec běžné školské aj a starší to i zúročil ve 13 letech v základních zkouškách. Letos se kluci připravovali na přijímací zk na gymnázia a obě slečny (čj/M) na doučování s nima opravdu jely a připravovaly. Mladší (7 tř.) byl 10. pod čarou a starší (9 tř.) dokonce 1. a 5. mezi přijatými u gymnázií, kam se hlásil. Po dvouleté pauze s covidem, děti potřebovaly dohnat látku pomalu za 3 měsíce a potrénovat na PZ, což se opravdu podařilo. Slečny jsou všechny, co jsme zatím měli, profesionálky s osobním přístupem a všechny moc milé. Výhodou je, že opravdu učení připraví dítěti na míru, s tím, co je potřeba a kde má mezery. Byli jsme opravdu spokojeni. Broumovi"
              />
              <Review
                name="Kristina Kik"
                stars={5}
                text="Výhodou určitě lektoři, kteří umí zaujmout – to je pro dnešní děti důležitý. A samozřejmě vědí, jak připravit a upozorní na pasti. Díky prvnímu i navazujícímu kurzu byly v našem případě přijímačky úspěšné, takže moc díky!!!"
              />
              <Review
                name="Kristyna Fercikova"
                stars={5}
                text="Doporučuju všem, Dohlavy mi pomohlo se naučit na přijímačky skvělým způsobem, se spoustou tipů a triků a vlastně 'hrou' Jasných 5⭐"
              />
              <Review
                name="Štětinová Štruncová Ivana"
                stars={5}
                text="Naprosto skvělá spolupráce, syn spokojený, postupně se zlepšuje v přípravě, rodiče spokojení – výborná komunikace a podpora."
              />
              <Review
                name="Ondřej Novák"
                stars={5}
                text="Výborná příprava k přijímačkám na střední školu. Skvělí lektoři, kteří doplní mezery ve vzdělání ze základní školy. Dcera dělala přijímačky na 2 gymnázia, a v obou se umístila na 1. místě. Jsme přesvědčeni, že to bylo právě díky absolvování online kurzu Dohlavy. Patří jim naše Díky..."
              />
              <Review
                name="Adrian Demeter"
                stars={5}
                text="Děkujeme za přípravné kurzy. Kurzy pomohly synovi získat až 47 bodů z matiky. A čeština taky dopadla velice dobře. Syn si neskutečně pochvaloval jak matikáře, tak i češtináře. Prý velice srozumitelně vysvětlovali učivo."
              />
              <Review
                name="Veronika Hrubešová"
                stars={5}
                text="Výborná kvalita doučování a skvělá komunikace, velmi doporučuji"
              />
              <Review
                name="Dana Melíšková"
                stars={5}
                text="super znalosti a přístup doporučených doučovatelů, slušné chování doučujících, bezproblémová komunikace se školou, celková spokojenost"
              />
              <Review
                name="Jana Mračková"
                stars={5}
                text="Syn se dostal díky kurzu a následné domácí přípravě na obě volené školy. (1. škola 38. místo z 372, 2. škola 27. místo z 148). Rozhodně návštěvu kurzů doporučuji, protože to má smysl. Lektoři jsou příjemní a dětem vše vysvětlí. Naučí je pracovat se záznamovými archy a také pár fíglů, jak se poprat s testovým zadáním. Tato investice se určitě vyplatila. "
              />
            </Slider>
            <button
              className="absolute top-[-25px] -right-12 h-[calc(100%+50px)] bg-transparent border-none cursor-pointer w-[130px] flex items-center justify-center"
              style={{ backgroundImage: `url(${ArrowBg})` }}
              type="button"
              onClick={handleNext}
            >
              <img src={ArrowNext} alt="" />
            </button>
            <div className="flex justify-center font-myriad text-white mt-8">
              <div className="flex items-center">
                <img
                  className="img-3"
                  src="https://c.animaapp.com/mbyttqkuyMhIPB/img/bxl-google.svg"
                />
                <div className="text-wrapper-21 me-3"> Google reviews</div>
                <img
                  className="star me-2"
                  src="https://c.animaapp.com/mbyttqkuyMhIPB/img/star-1.svg"
                />
                <div className="text-wrapper-20">5.0</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Reviews
